export default {
  trackEvent (eventName, eventData) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, eventData)
    }
  }
}



// WEBPACK FOOTER //
// ./WebResources/vue/shared/lib/google-analytics-v4.js